// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64821d76","453":"a42ab727","567":"82b1fd19","665":"429e4bb3","802":"53f28fc0","940":"be7dc447"}[chunkId] + ".chunk.js";
};